import CONFIG from '@/config'

import {
	wxuuid,
	redirectToAuth,
	retryGetToken
} from './utils.js'

export const http = (url, method) => {
	return ((data, extraParams) => {
		return new Promise(async (resolve, reject) => {
			let nonceStr = wxuuid()
			let header = {
				nonce: nonceStr
			}
			if (uni.getStorageSync('userId')) {
				header.userId = uni.getStorageSync('userId')
			}


			if(uni.getStorageSync('token')) header.token = uni.getStorageSync('token')
			// header.token = 'eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCIsInRlYW0iOiJzdW9oYSB0ZWFtIGRldmVsb3AifQ.eyJpc3MiOiJzdW9oYSBzeXN0ZW0iLCJleHAiOjE3ODE4NDk4NTQsImp0aSI6IjM3NDAwMDUxNTcxMTU2OTExNjMifQ.6TLSkFv1Pe66yYQtx10dmZukVo1YrTLufcJ5g6moZRQqcWVNaCN4zGyPmYT6wWku'
			url = url.indexOf('https') > -1 ? url : CONFIG.baseUrl + url






			uni.request({
				// 标识小程序
				url: extraParams ? url + extraParams : url,
				method: method,
				data: data,
				header: header,
				success: async (res) => {
					if (res.data.code === 200 || res.data.code === 403 || res.data.code === 0) {
						resolve(res.data.data)
					} else {
						if (res.data.code === 401) {
							uni.removeStorageSync('token')

							redirectToAuth()







						} else {
							uni.showToast({
								title: res.data.msg,
								duration: 2000
							})
						}
					}
				},
				fail: (rej) => {
					uni.showToast({
						title: rej.errMsg,
						duration: 2000,
						icon: 'error'
					})
				}
			})
		})
	})
}
